import logo_ad from "../flags/ad.svg";
import logo_ae from "../flags/ae.svg";
import logo_af from "../flags/af.svg";
import logo_ag from "../flags/ag.svg";
import logo_ai from "../flags/ai.svg";
import logo_al from "../flags/al.svg";
import logo_am from "../flags/am.svg";
import logo_ao from "../flags/ao.svg";
import logo_aq from "../flags/aq.svg";
import logo_ar from "../flags/ar.svg";
import logo_as from "../flags/as.svg";
import logo_at from "../flags/at.svg";
import logo_au from "../flags/au.svg";
import logo_aw from "../flags/aw.svg";
import logo_ax from "../flags/ax.svg";
import logo_az from "../flags/az.svg";
import logo_ba from "../flags/ba.svg";
import logo_bb from "../flags/bb.svg";
import logo_bd from "../flags/bd.svg";
import logo_be from "../flags/be.svg";
import logo_bf from "../flags/bf.svg";
import logo_bg from "../flags/bg.svg";
import logo_bh from "../flags/bh.svg";
import logo_bi from "../flags/bi.svg";
import logo_bj from "../flags/bj.svg";
import logo_bl from "../flags/bl.svg";
import logo_bm from "../flags/bm.svg";
import logo_bn from "../flags/bn.svg";
import logo_bo from "../flags/bo.svg";
import logo_bq from "../flags/bq.svg";
import logo_br from "../flags/br.svg";
import logo_bs from "../flags/bs.svg";
import logo_bt from "../flags/bt.svg";
import logo_bv from "../flags/bv.svg";
import logo_bw from "../flags/bw.svg";
import logo_by from "../flags/by.svg";
import logo_bz from "../flags/bz.svg";
import logo_ca from "../flags/ca.svg";
import logo_cc from "../flags/cc.svg";
import logo_cd from "../flags/cd.svg";
import logo_cf from "../flags/cf.svg";
import logo_cg from "../flags/cg.svg";
import logo_ch from "../flags/ch.svg";
import logo_ci from "../flags/ci.svg";
import logo_ck from "../flags/ck.svg";
import logo_cl from "../flags/cl.svg";
import logo_cm from "../flags/cm.svg";
import logo_cn from "../flags/cn.svg";
import logo_co from "../flags/co.svg";
import logo_cr from "../flags/cr.svg";
import logo_cu from "../flags/cu.svg";
import logo_cv from "../flags/cv.svg";
import logo_cw from "../flags/cw.svg";
import logo_cx from "../flags/cx.svg";
import logo_cy from "../flags/cy.svg";
import logo_cz from "../flags/cz.svg";
import logo_de from "../flags/de.svg";
import logo_dj from "../flags/dj.svg";
import logo_dk from "../flags/dk.svg";
import logo_dm from "../flags/dm.svg";
import logo_do from "../flags/do.svg";
import logo_dz from "../flags/dz.svg";
import logo_ec from "../flags/ec.svg";
import logo_ee from "../flags/ee.svg";
import logo_eg from "../flags/eg.svg";
import logo_eh from "../flags/eh.svg";
import logo_er from "../flags/er.svg";
import logo_es from "../flags/es.svg";
import logo_et from "../flags/et.svg";
import logo_eu from "../flags/eu.svg";
import logo_fi from "../flags/fi.svg";
import logo_fj from "../flags/fj.svg";
import logo_fk from "../flags/fk.svg";
import logo_fm from "../flags/fm.svg";
import logo_fo from "../flags/fo.svg";
import logo_fr from "../flags/fr.svg";
import logo_ga from "../flags/ga.svg";
import logo_gb_eng from "../flags/gb-eng.svg";
import logo_gb_sct from "../flags/gb-sct.svg";
import logo_gb_wls from "../flags/gb-wls.svg";
import logo_gb from "../flags/gb.svg";
import logo_gd from "../flags/gd.svg";
import logo_ge from "../flags/ge.svg";
import logo_gf from "../flags/gf.svg";
import logo_gg from "../flags/gg.svg";
import logo_gh from "../flags/gh.svg";
import logo_gi from "../flags/gi.svg";
import logo_gl from "../flags/gl.svg";
import logo_gm from "../flags/gm.svg";
import logo_gn from "../flags/gn.svg";
import logo_gp from "../flags/gp.svg";
import logo_gq from "../flags/gq.svg";
import logo_gr from "../flags/gr.svg";
import logo_gs from "../flags/gs.svg";
import logo_gt from "../flags/gt.svg";
import logo_gu from "../flags/gu.svg";
import logo_gw from "../flags/gw.svg";
import logo_gy from "../flags/gy.svg";
import logo_hk from "../flags/hk.svg";
import logo_hm from "../flags/hm.svg";
import logo_hn from "../flags/hn.svg";
import logo_hr from "../flags/hr.svg";
import logo_ht from "../flags/ht.svg";
import logo_hu from "../flags/hu.svg";
import logo_id from "../flags/id.svg";
import logo_ie from "../flags/ie.svg";
import logo_il from "../flags/il.svg";
import logo_im from "../flags/im.svg";
import logo_in from "../flags/in.svg";
import logo_io from "../flags/io.svg";
import logo_iq from "../flags/iq.svg";
import logo_ir from "../flags/ir.svg";
import logo_is from "../flags/is.svg";
import logo_it from "../flags/it.svg";
import logo_je from "../flags/je.svg";
import logo_jm from "../flags/jm.svg";
import logo_jo from "../flags/jo.svg";
import logo_jp from "../flags/jp.svg";
import logo_ke from "../flags/ke.svg";
import logo_kg from "../flags/kg.svg";
import logo_kh from "../flags/kh.svg";
import logo_ki from "../flags/ki.svg";
import logo_km from "../flags/km.svg";
import logo_kn from "../flags/kn.svg";
import logo_kp from "../flags/kp.svg";
import logo_kr from "../flags/kr.svg";
import logo_kw from "../flags/kw.svg";
import logo_ky from "../flags/ky.svg";
import logo_kz from "../flags/kz.svg";
import logo_la from "../flags/la.svg";
import logo_lb from "../flags/lb.svg";
import logo_lc from "../flags/lc.svg";
import logo_li from "../flags/li.svg";
import logo_lk from "../flags/lk.svg";
import logo_lr from "../flags/lr.svg";
import logo_ls from "../flags/ls.svg";
import logo_lt from "../flags/lt.svg";
import logo_lu from "../flags/lu.svg";
import logo_lv from "../flags/lv.svg";
import logo_ly from "../flags/ly.svg";
import logo_ma from "../flags/ma.svg";
import logo_mc from "../flags/mc.svg";
import logo_md from "../flags/md.svg";
import logo_me from "../flags/me.svg";
import logo_mf from "../flags/mf.svg";
import logo_mg from "../flags/mg.svg";
import logo_mh from "../flags/mh.svg";
import logo_mk from "../flags/mk.svg";
import logo_ml from "../flags/ml.svg";
import logo_mm from "../flags/mm.svg";
import logo_mn from "../flags/mn.svg";
import logo_mo from "../flags/mo.svg";
import logo_mp from "../flags/mp.svg";
import logo_mq from "../flags/mq.svg";
import logo_mr from "../flags/mr.svg";
import logo_ms from "../flags/ms.svg";
import logo_mt from "../flags/mt.svg";
import logo_mu from "../flags/mu.svg";
import logo_mv from "../flags/mv.svg";
import logo_mw from "../flags/mw.svg";
import logo_mx from "../flags/mx.svg";
import logo_my from "../flags/my.svg";
import logo_mz from "../flags/mz.svg";
import logo_na from "../flags/na.svg";
import logo_nc from "../flags/nc.svg";
import logo_ne from "../flags/ne.svg";
import logo_nf from "../flags/nf.svg";
import logo_ng from "../flags/ng.svg";
import logo_ni from "../flags/ni.svg";
import logo_nl from "../flags/nl.svg";
import logo_no from "../flags/no.svg";
import logo_np from "../flags/np.svg";
import logo_nr from "../flags/nr.svg";
import logo_nu from "../flags/nu.svg";
import logo_nz from "../flags/nz.svg";
import logo_om from "../flags/om.svg";
import logo_pa from "../flags/pa.svg";
import logo_pe from "../flags/pe.svg";
import logo_pf from "../flags/pf.svg";
import logo_pg from "../flags/pg.svg";
import logo_ph from "../flags/ph.svg";
import logo_pk from "../flags/pk.svg";
import logo_pl from "../flags/pl.svg";
import logo_pm from "../flags/pm.svg";
import logo_pn from "../flags/pn.svg";
import logo_pr from "../flags/pr.svg";
import logo_ps from "../flags/ps.svg";
import logo_pt from "../flags/pt.svg";
import logo_pw from "../flags/pw.svg";
import logo_py from "../flags/py.svg";
import logo_qa from "../flags/qa.svg";
import logo_re from "../flags/re.svg";
import logo_ro from "../flags/ro.svg";
import logo_rs from "../flags/rs.svg";
import logo_ru from "../flags/ru.svg";
import logo_rw from "../flags/rw.svg";
import logo_sa from "../flags/sa.svg";
import logo_sb from "../flags/sb.svg";
import logo_sc from "../flags/sc.svg";
import logo_sd from "../flags/sd.svg";
import logo_se from "../flags/se.svg";
import logo_sg from "../flags/sg.svg";
import logo_sh from "../flags/sh.svg";
import logo_si from "../flags/si.svg";
import logo_sj from "../flags/sj.svg";
import logo_sk from "../flags/sk.svg";
import logo_sl from "../flags/sl.svg";
import logo_sm from "../flags/sm.svg";
import logo_sn from "../flags/sn.svg";
import logo_so from "../flags/so.svg";
import logo_sr from "../flags/sr.svg";
import logo_ss from "../flags/ss.svg";
import logo_st from "../flags/st.svg";
import logo_sv from "../flags/sv.svg";
import logo_sx from "../flags/sx.svg";
import logo_sy from "../flags/sy.svg";
import logo_sz from "../flags/sz.svg";
import logo_tc from "../flags/tc.svg";
import logo_td from "../flags/td.svg";
import logo_tf from "../flags/tf.svg";
import logo_tg from "../flags/tg.svg";
import logo_th from "../flags/th.svg";
import logo_tj from "../flags/tj.svg";
import logo_tk from "../flags/tk.svg";
import logo_tl from "../flags/tl.svg";
import logo_tm from "../flags/tm.svg";
import logo_tn from "../flags/tn.svg";
import logo_to from "../flags/to.svg";
import logo_tr from "../flags/tr.svg";
import logo_tt from "../flags/tt.svg";
import logo_tv from "../flags/tv.svg";
import logo_tw from "../flags/tw.svg";
import logo_tz from "../flags/tz.svg";
import logo_ua from "../flags/ua.svg";
import logo_ug from "../flags/ug.svg";
import logo_uk from "../flags/uk.svg";
import logo_um from "../flags/um.svg";
import logo_un from "../flags/un.svg";
import logo_us from "../flags/us.svg";
import logo_uy from "../flags/uy.svg";
import logo_uz from "../flags/uz.svg";
import logo_va from "../flags/va.svg";
import logo_vc from "../flags/vc.svg";
import logo_ve from "../flags/ve.svg";
import logo_vg from "../flags/vg.svg";
import logo_vi from "../flags/vi.svg";
import logo_vn from "../flags/vn.svg";
import logo_vu from "../flags/vu.svg";
import logo_wf from "../flags/wf.svg";
import logo_ws from "../flags/ws.svg";
import logo_ye from "../flags/ye.svg";
import logo_yt from "../flags/yt.svg";
import logo_za from "../flags/za.svg";
import logo_zm from "../flags/zm.svg";
import logo_zw from "../flags/zw.svg";
import logo_zz from "../flags/zz.svg";


export default function Svg_icon(param: any) {

    console.log(param)


    return (<>

        {
            (() => {
                if (param.IName.toLowerCase() == "ad") { return <img alt="Korrect"  src={logo_ad} className="width30" /> }
                if (param.IName.toLowerCase() == "ae") { return <img alt="Korrect"  src={logo_ae} className="width30" /> }
                if (param.IName.toLowerCase() == "af") { return <img alt="Korrect"  src={logo_af} className="width30" /> }
                if (param.IName.toLowerCase() == "ag") { return <img alt="Korrect"  src={logo_ag} className="width30" /> }
                if (param.IName.toLowerCase() == "ai") { return <img alt="Korrect"  src={logo_ai} className="width30" /> }
                if (param.IName.toLowerCase() == "al") { return <img alt="Korrect"  src={logo_al} className="width30" /> }
                if (param.IName.toLowerCase() == "am") { return <img alt="Korrect"  src={logo_am} className="width30" /> }
                if (param.IName.toLowerCase() == "ao") { return <img alt="Korrect"  src={logo_ao} className="width30" /> }
                if (param.IName.toLowerCase() == "aq") { return <img alt="Korrect"  src={logo_aq} className="width30" /> }
                if (param.IName.toLowerCase() == "ar") { return <img alt="Korrect"  src={logo_ar} className="width30" /> }
                if (param.IName.toLowerCase() == "as") { return <img alt="Korrect"  src={logo_as} className="width30" /> }
                if (param.IName.toLowerCase() == "at") { return <img alt="Korrect"  src={logo_at} className="width30" /> }
                if (param.IName.toLowerCase() == "au") { return <img alt="Korrect"  src={logo_au} className="width30" /> }
                if (param.IName.toLowerCase() == "aw") { return <img alt="Korrect"  src={logo_aw} className="width30" /> }
                if (param.IName.toLowerCase() == "ax") { return <img alt="Korrect"  src={logo_ax} className="width30" /> }
                if (param.IName.toLowerCase() == "az") { return <img alt="Korrect"  src={logo_az} className="width30" /> }

                if (param.IName.toLowerCase() == "ba") { return <img alt="Korrect"  src={logo_ba} className="width30" /> }
                if (param.IName.toLowerCase() == "bb") { return <img alt="Korrect"  src={logo_bb} className="width30" /> }
                if (param.IName.toLowerCase() == "bd") { return <img alt="Korrect"  src={logo_bd} className="width30" /> }
                if (param.IName.toLowerCase() == "be") { return <img alt="Korrect"  src={logo_be} className="width30" /> }
                if (param.IName.toLowerCase() == "bf") { return <img alt="Korrect"  src={logo_bf} className="width30" /> }
                if (param.IName.toLowerCase() == "bg") { return <img alt="Korrect"  src={logo_bg} className="width30" /> }
                if (param.IName.toLowerCase() == "bh") { return <img alt="Korrect"  src={logo_bh} className="width30" /> }
                if (param.IName.toLowerCase() == "bi") { return <img alt="Korrect"  src={logo_bi} className="width30" /> }
                if (param.IName.toLowerCase() == "bj") { return <img alt="Korrect"  src={logo_bj} className="width30" /> }
                if (param.IName.toLowerCase() == "bl") { return <img alt="Korrect"  src={logo_bl} className="width30" /> }
                if (param.IName.toLowerCase() == "bm") { return <img alt="Korrect"  src={logo_bm} className="width30" /> }
                if (param.IName.toLowerCase() == "bn") { return <img alt="Korrect"  src={logo_bn} className="width30" /> }
                if (param.IName.toLowerCase() == "bo") { return <img alt="Korrect"  src={logo_bo} className="width30" /> }
                if (param.IName.toLowerCase() == "bq") { return <img alt="Korrect"  src={logo_bq} className="width30" /> }
                if (param.IName.toLowerCase() == "br") { return <img alt="Korrect"  src={logo_br} className="width30" /> }
                if (param.IName.toLowerCase() == "bs") { return <img alt="Korrect"  src={logo_bs} className="width30" /> }
                if (param.IName.toLowerCase() == "bt") { return <img alt="Korrect"  src={logo_bt} className="width30" /> }
                if (param.IName.toLowerCase() == "bv") { return <img alt="Korrect"  src={logo_bv} className="width30" /> }
                if (param.IName.toLowerCase() == "bw") { return <img alt="Korrect"  src={logo_bw} className="width30" /> }
                if (param.IName.toLowerCase() == "by") { return <img alt="Korrect"  src={logo_by} className="width30" /> }
                if (param.IName.toLowerCase() == "bz") { return <img alt="Korrect"  src={logo_bz} className="width30" /> }

                if (param.IName.toLowerCase() == "ca") { return <img alt="Korrect"  src={logo_ca} className="width30" /> }
                if (param.IName.toLowerCase() == "cc") { return <img alt="Korrect"  src={logo_cc} className="width30" /> }
                if (param.IName.toLowerCase() == "cd") { return <img alt="Korrect"  src={logo_cd} className="width30" /> }
                if (param.IName.toLowerCase() == "cf") { return <img alt="Korrect"  src={logo_cf} className="width30" /> }
                if (param.IName.toLowerCase() == "cg") { return <img alt="Korrect"  src={logo_cg} className="width30" /> }
                if (param.IName.toLowerCase() == "ch") { return <img alt="Korrect"  src={logo_ch} className="width30" /> }
                if (param.IName.toLowerCase() == "ci") { return <img alt="Korrect"  src={logo_ci} className="width30" /> }
                if (param.IName.toLowerCase() == "ck") { return <img alt="Korrect"  src={logo_ck} className="width30" /> }
                if (param.IName.toLowerCase() == "cl") { return <img alt="Korrect"  src={logo_cl} className="width30" /> }
                if (param.IName.toLowerCase() == "cm") { return <img alt="Korrect"  src={logo_cm} className="width30" /> }
                if (param.IName.toLowerCase() == "cn") { return <img alt="Korrect"  src={logo_cn} className="width30" /> }
                if (param.IName.toLowerCase() == "co") { return <img alt="Korrect"  src={logo_co} className="width30" /> }
                if (param.IName.toLowerCase() == "cr") { return <img alt="Korrect"  src={logo_cr} className="width30" /> }
                if (param.IName.toLowerCase() == "cu") { return <img alt="Korrect"  src={logo_cu} className="width30" /> }
                if (param.IName.toLowerCase() == "cv") { return <img alt="Korrect"  src={logo_cv} className="width30" /> }
                if (param.IName.toLowerCase() == "cw") { return <img alt="Korrect"  src={logo_cw} className="width30" /> }
                if (param.IName.toLowerCase() == "cx") { return <img alt="Korrect"  src={logo_cx} className="width30" /> }
                if (param.IName.toLowerCase() == "cy") { return <img alt="Korrect"  src={logo_cy} className="width30" /> }
                if (param.IName.toLowerCase() == "cz") { return <img alt="Korrect"  src={logo_cz} className="width30" /> }

                if (param.IName.toLowerCase() == "de") { return <img alt="Korrect"  src={logo_de} className="width30" /> }
                if (param.IName.toLowerCase() == "dj") { return <img alt="Korrect"  src={logo_dj} className="width30" /> }
                if (param.IName.toLowerCase() == "dk") { return <img alt="Korrect"  src={logo_dk} className="width30" /> }
                if (param.IName.toLowerCase() == "dm") { return <img alt="Korrect"  src={logo_dm} className="width30" /> }
                if (param.IName.toLowerCase() == "do") { return <img alt="Korrect"  src={logo_do} className="width30" /> }
                if (param.IName.toLowerCase() == "dz") { return <img alt="Korrect"  src={logo_dz} className="width30" /> }

                if (param.IName.toLowerCase() == "ec") { return <img alt="Korrect"  src={logo_ec} className="width30" /> }
                if (param.IName.toLowerCase() == "ee") { return <img alt="Korrect"  src={logo_ee} className="width30" /> }
                if (param.IName.toLowerCase() == "eg") { return <img alt="Korrect"  src={logo_eg} className="width30" /> }
                if (param.IName.toLowerCase() == "eh") { return <img alt="Korrect"  src={logo_eh} className="width30" /> }
                if (param.IName.toLowerCase() == "er") { return <img alt="Korrect"  src={logo_er} className="width30" /> }
                if (param.IName.toLowerCase() == "es") { return <img alt="Korrect"  src={logo_es} className="width30" /> }
                if (param.IName.toLowerCase() == "et") { return <img alt="Korrect"  src={logo_et} className="width30" /> }
                if (param.IName.toLowerCase() == "eu") { return <img alt="Korrect"  src={logo_eu} className="width30" /> }

                if (param.IName.toLowerCase() == "fi") { return <img alt="Korrect"  src={logo_fi} className="width30" /> }
                if (param.IName.toLowerCase() == "fj") { return <img alt="Korrect"  src={logo_fj} className="width30" /> }
                if (param.IName.toLowerCase() == "fk") { return <img alt="Korrect"  src={logo_fk} className="width30" /> }
                if (param.IName.toLowerCase() == "fm") { return <img alt="Korrect"  src={logo_fm} className="width30" /> }
                if (param.IName.toLowerCase() == "fo") { return <img alt="Korrect"  src={logo_fo} className="width30" /> }
                if (param.IName.toLowerCase() == "fr") { return <img alt="Korrect"  src={logo_fr} className="width30" /> }

                if (param.IName.toLowerCase() == "ga") { return <img alt="Korrect"  src={logo_ga} className="width30" /> }
                if (param.IName.toLowerCase() == "gb-eng") { return <img alt="Korrect"  src={logo_gb_eng} className="width30" /> }
                if (param.IName.toLowerCase() == "gb-sct") { return <img alt="Korrect"  src={logo_gb_sct} className="width30" /> }
                if (param.IName.toLowerCase() == "gb-wls") { return <img alt="Korrect"  src={logo_gb_wls} className="width30" /> }
                if (param.IName.toLowerCase() == "gb") { return <img alt="Korrect"  src={logo_gb} className="width30" /> }
                if (param.IName.toLowerCase() == "gd") { return <img alt="Korrect"  src={logo_gd} className="width30" /> }
                if (param.IName.toLowerCase() == "ge") { return <img alt="Korrect"  src={logo_ge} className="width30" /> }
                if (param.IName.toLowerCase() == "gf") { return <img alt="Korrect"  src={logo_gf} className="width30" /> }
                if (param.IName.toLowerCase() == "gg") { return <img alt="Korrect"  src={logo_gg} className="width30" /> }
                if (param.IName.toLowerCase() == "gh") { return <img alt="Korrect"  src={logo_gh} className="width30" /> }
                if (param.IName.toLowerCase() == "gi") { return <img alt="Korrect"  src={logo_gi} className="width30" /> }
                if (param.IName.toLowerCase() == "gl") { return <img alt="Korrect"  src={logo_gl} className="width30" /> }
                if (param.IName.toLowerCase() == "gm") { return <img alt="Korrect"  src={logo_gm} className="width30" /> }
                if (param.IName.toLowerCase() == "gn") { return <img alt="Korrect"  src={logo_gn} className="width30" /> }
                if (param.IName.toLowerCase() == "gp") { return <img alt="Korrect"  src={logo_gp} className="width30" /> }
                if (param.IName.toLowerCase() == "gq") { return <img alt="Korrect"  src={logo_gq} className="width30" /> }
                if (param.IName.toLowerCase() == "gr") { return <img alt="Korrect"  src={logo_gr} className="width30" /> }
                if (param.IName.toLowerCase() == "gs") { return <img alt="Korrect"  src={logo_gs} className="width30" /> }
                if (param.IName.toLowerCase() == "gt") { return <img alt="Korrect"  src={logo_gt} className="width30" /> }
                if (param.IName.toLowerCase() == "gu") { return <img alt="Korrect"  src={logo_gu} className="width30" /> }
                if (param.IName.toLowerCase() == "gw") { return <img alt="Korrect"  src={logo_gw} className="width30" /> }
                if (param.IName.toLowerCase() == "gy") { return <img alt="Korrect"  src={logo_gy} className="width30" /> }

                if (param.IName.toLowerCase() == "hk") { return <img alt="Korrect"  src={logo_hk} className="width30" /> }
                if (param.IName.toLowerCase() == "hm") { return <img alt="Korrect"  src={logo_hm} className="width30" /> }
                if (param.IName.toLowerCase() == "hn") { return <img alt="Korrect"  src={logo_hn} className="width30" /> }
                if (param.IName.toLowerCase() == "hr") { return <img alt="Korrect"  src={logo_hr} className="width30" /> }
                if (param.IName.toLowerCase() == "ht") { return <img alt="Korrect"  src={logo_ht} className="width30" /> }
                if (param.IName.toLowerCase() == "hu") { return <img alt="Korrect"  src={logo_hu} className="width30" /> }

                if (param.IName.toLowerCase() == "id") { return <img alt="Korrect"  src={logo_id} className="width30" /> }
                if (param.IName.toLowerCase() == "ie") { return <img alt="Korrect"  src={logo_ie} className="width30" /> }
                if (param.IName.toLowerCase() == "il") { return <img alt="Korrect"  src={logo_il} className="width30" /> }
                if (param.IName.toLowerCase() == "im") { return <img alt="Korrect"  src={logo_im} className="width30" /> }
                if (param.IName.toLowerCase() == "in") { return <img alt="Korrect"  src={logo_in} className="width30" /> }
                if (param.IName.toLowerCase() == "io") { return <img alt="Korrect"  src={logo_io} className="width30" /> }
                if (param.IName.toLowerCase() == "iq") { return <img alt="Korrect"  src={logo_iq} className="width30" /> }
                if (param.IName.toLowerCase() == "ir") { return <img alt="Korrect"  src={logo_ir} className="width30" /> }
                if (param.IName.toLowerCase() == "is") { return <img alt="Korrect"  src={logo_is} className="width30" /> }
                if (param.IName.toLowerCase() == "it") { return <img alt="Korrect"  src={logo_it} className="width30" /> }

                if (param.IName.toLowerCase() == "je") { return <img alt="Korrect"  src={logo_je} className="width30" /> }
                if (param.IName.toLowerCase() == "jm") { return <img alt="Korrect"  src={logo_jm} className="width30" /> }
                if (param.IName.toLowerCase() == "jo") { return <img alt="Korrect"  src={logo_jo} className="width30" /> }
                if (param.IName.toLowerCase() == "jp") { return <img alt="Korrect"  src={logo_jp} className="width30" /> }

                if (param.IName.toLowerCase() == "ke") { return <img alt="Korrect"  src={logo_ke} className="width30" /> }
                if (param.IName.toLowerCase() == "kg") { return <img alt="Korrect"  src={logo_kg} className="width30" /> }
                if (param.IName.toLowerCase() == "kh") { return <img alt="Korrect"  src={logo_kh} className="width30" /> }
                if (param.IName.toLowerCase() == "ki") { return <img alt="Korrect"  src={logo_ki} className="width30" /> }
                if (param.IName.toLowerCase() == "km") { return <img alt="Korrect"  src={logo_km} className="width30" /> }
                if (param.IName.toLowerCase() == "kn") { return <img alt="Korrect"  src={logo_kn} className="width30" /> }
                if (param.IName.toLowerCase() == "kp") { return <img alt="Korrect"  src={logo_kp} className="width30" /> }
                if (param.IName.toLowerCase() == "kr") { return <img alt="Korrect"  src={logo_kr} className="width30" /> }
                if (param.IName.toLowerCase() == "kw") { return <img alt="Korrect"  src={logo_kw} className="width30" /> }
                if (param.IName.toLowerCase() == "ky") { return <img alt="Korrect"  src={logo_ky} className="width30" /> }
                if (param.IName.toLowerCase() == "kz") { return <img alt="Korrect"  src={logo_kz} className="width30" /> }

                if (param.IName.toLowerCase() == "la") { return <img alt="Korrect"  src={logo_la} className="width30" /> }
                if (param.IName.toLowerCase() == "lb") { return <img alt="Korrect"  src={logo_lb} className="width30" /> }
                if (param.IName.toLowerCase() == "lc") { return <img alt="Korrect"  src={logo_lc} className="width30" /> }
                if (param.IName.toLowerCase() == "li") { return <img alt="Korrect"  src={logo_li} className="width30" /> }
                if (param.IName.toLowerCase() == "lk") { return <img alt="Korrect"  src={logo_lk} className="width30" /> }
                if (param.IName.toLowerCase() == "lr") { return <img alt="Korrect"  src={logo_lr} className="width30" /> }
                if (param.IName.toLowerCase() == "ls") { return <img alt="Korrect"  src={logo_ls} className="width30" /> }
                if (param.IName.toLowerCase() == "lt") { return <img alt="Korrect"  src={logo_lt} className="width30" /> }
                if (param.IName.toLowerCase() == "lu") { return <img alt="Korrect"  src={logo_lu} className="width30" /> }
                if (param.IName.toLowerCase() == "lv") { return <img alt="Korrect"  src={logo_lv} className="width30" /> }
                if (param.IName.toLowerCase() == "ly") { return <img alt="Korrect"  src={logo_ly} className="width30" /> }

                if (param.IName.toLowerCase() == "ma") { return <img alt="Korrect"  src={logo_ma} className="width30" /> }
                if (param.IName.toLowerCase() == "mc") { return <img alt="Korrect"  src={logo_mc} className="width30" /> }
                if (param.IName.toLowerCase() == "md") { return <img alt="Korrect"  src={logo_md} className="width30" /> }
                if (param.IName.toLowerCase() == "me") { return <img alt="Korrect"  src={logo_me} className="width30" /> }
                if (param.IName.toLowerCase() == "mf") { return <img alt="Korrect"  src={logo_mf} className="width30" /> }
                if (param.IName.toLowerCase() == "mg") { return <img alt="Korrect"  src={logo_mg} className="width30" /> }
                if (param.IName.toLowerCase() == "mh") { return <img alt="Korrect"  src={logo_mh} className="width30" /> }
                if (param.IName.toLowerCase() == "mk") { return <img alt="Korrect"  src={logo_mk} className="width30" /> }
                if (param.IName.toLowerCase() == "ml") { return <img alt="Korrect"  src={logo_ml} className="width30" /> }
                if (param.IName.toLowerCase() == "mm") { return <img alt="Korrect"  src={logo_mm} className="width30" /> }
                if (param.IName.toLowerCase() == "mn") { return <img alt="Korrect"  src={logo_mn} className="width30" /> }
                if (param.IName.toLowerCase() == "mo") { return <img alt="Korrect"  src={logo_mo} className="width30" /> }
                if (param.IName.toLowerCase() == "mp") { return <img alt="Korrect"  src={logo_mp} className="width30" /> }
                if (param.IName.toLowerCase() == "mq") { return <img alt="Korrect"  src={logo_mq} className="width30" /> }
                if (param.IName.toLowerCase() == "mr") { return <img alt="Korrect"  src={logo_mr} className="width30" /> }
                if (param.IName.toLowerCase() == "ms") { return <img alt="Korrect"  src={logo_ms} className="width30" /> }
                if (param.IName.toLowerCase() == "mt") { return <img alt="Korrect"  src={logo_mt} className="width30" /> }
                if (param.IName.toLowerCase() == "mu") { return <img alt="Korrect"  src={logo_mu} className="width30" /> }
                if (param.IName.toLowerCase() == "mv") { return <img alt="Korrect"  src={logo_mv} className="width30" /> }
                if (param.IName.toLowerCase() == "mw") { return <img alt="Korrect"  src={logo_mw} className="width30" /> }
                if (param.IName.toLowerCase() == "mx") { return <img alt="Korrect"  src={logo_mx} className="width30" /> }
                if (param.IName.toLowerCase() == "my") { return <img alt="Korrect"  src={logo_my} className="width30" /> }
                if (param.IName.toLowerCase() == "mz") { return <img alt="Korrect"  src={logo_mz} className="width30" /> }

                if (param.IName.toLowerCase() == "na") { return <img alt="Korrect"  src={logo_na} className="width30" /> }
                if (param.IName.toLowerCase() == "nc") { return <img alt="Korrect"  src={logo_nc} className="width30" /> }
                if (param.IName.toLowerCase() == "ne") { return <img alt="Korrect"  src={logo_ne} className="width30" /> }
                if (param.IName.toLowerCase() == "nf") { return <img alt="Korrect"  src={logo_nf} className="width30" /> }
                if (param.IName.toLowerCase() == "ng") { return <img alt="Korrect"  src={logo_ng} className="width30" /> }
                if (param.IName.toLowerCase() == "ni") { return <img alt="Korrect"  src={logo_ni} className="width30" /> }
                if (param.IName.toLowerCase() == "nl") { return <img alt="Korrect"  src={logo_nl} className="width30" /> }
                if (param.IName.toLowerCase() == "no") { return <img alt="Korrect"  src={logo_no} className="width30" /> }
                if (param.IName.toLowerCase() == "np") { return <img alt="Korrect"  src={logo_np} className="width30" /> }
                if (param.IName.toLowerCase() == "nr") { return <img alt="Korrect"  src={logo_nr} className="width30" /> }
                if (param.IName.toLowerCase() == "nu") { return <img alt="Korrect"  src={logo_nu} className="width30" /> }
                if (param.IName.toLowerCase() == "nz") { return <img alt="Korrect"  src={logo_nz} className="width30" /> }

                if (param.IName.toLowerCase() == "om") { return <img alt="Korrect"  src={logo_om} className="width30" /> }

                if (param.IName.toLowerCase() == "pa") { return <img alt="Korrect"  src={logo_pa} className="width30" /> }
                if (param.IName.toLowerCase() == "pe") { return <img alt="Korrect"  src={logo_pe} className="width30" /> }
                if (param.IName.toLowerCase() == "pf") { return <img alt="Korrect"  src={logo_pf} className="width30" /> }
                if (param.IName.toLowerCase() == "pg") { return <img alt="Korrect"  src={logo_pg} className="width30" /> }
                if (param.IName.toLowerCase() == "ph") { return <img alt="Korrect"  src={logo_ph} className="width30" /> }
                if (param.IName.toLowerCase() == "pk") { return <img alt="Korrect"  src={logo_pk} className="width30" /> }
                if (param.IName.toLowerCase() == "pl") { return <img alt="Korrect"  src={logo_pl} className="width30" /> }
                if (param.IName.toLowerCase() == "pm") { return <img alt="Korrect"  src={logo_pm} className="width30" /> }
                if (param.IName.toLowerCase() == "pn") { return <img alt="Korrect"  src={logo_pn} className="width30" /> }
                if (param.IName.toLowerCase() == "pr") { return <img alt="Korrect"  src={logo_pr} className="width30" /> }
                if (param.IName.toLowerCase() == "ps") { return <img alt="Korrect"  src={logo_ps} className="width30" /> }
                if (param.IName.toLowerCase() == "pt") { return <img alt="Korrect"  src={logo_pt} className="width30" /> }
                if (param.IName.toLowerCase() == "pw") { return <img alt="Korrect"  src={logo_pw} className="width30" /> }
                if (param.IName.toLowerCase() == "py") { return <img alt="Korrect"  src={logo_py} className="width30" /> }
                if (param.IName.toLowerCase() == "qa") { return <img alt="Korrect"  src={logo_qa} className="width30" /> }

                if (param.IName.toLowerCase() == "re") { return <img alt="Korrect"  src={logo_re} className="width30" /> }
                if (param.IName.toLowerCase() == "ro") { return <img alt="Korrect"  src={logo_ro} className="width30" /> }
                if (param.IName.toLowerCase() == "rs") { return <img alt="Korrect"  src={logo_rs} className="width30" /> }
                if (param.IName.toLowerCase() == "ru") { return <img alt="Korrect"  src={logo_ru} className="width30" /> }
                if (param.IName.toLowerCase() == "rw") { return <img alt="Korrect"  src={logo_rw} className="width30" /> }

                if (param.IName.toLowerCase() == "sa") { return <img alt="Korrect"  src={logo_sa} className="width30" /> }
                if (param.IName.toLowerCase() == "sb") { return <img alt="Korrect"  src={logo_sb} className="width30" /> }
                if (param.IName.toLowerCase() == "sc") { return <img alt="Korrect"  src={logo_sc} className="width30" /> }
                if (param.IName.toLowerCase() == "sd") { return <img alt="Korrect"  src={logo_sd} className="width30" /> }
                if (param.IName.toLowerCase() == "se") { return <img alt="Korrect"  src={logo_se} className="width30" /> }
                if (param.IName.toLowerCase() == "sg") { return <img alt="Korrect"  src={logo_sg} className="width30" /> }
                if (param.IName.toLowerCase() == "sh") { return <img alt="Korrect"  src={logo_sh} className="width30" /> }
                if (param.IName.toLowerCase() == "si") { return <img alt="Korrect"  src={logo_si} className="width30" /> }
                if (param.IName.toLowerCase() == "sj") { return <img alt="Korrect"  src={logo_sj} className="width30" /> }
                if (param.IName.toLowerCase() == "sk") { return <img alt="Korrect"  src={logo_sk} className="width30" /> }
                if (param.IName.toLowerCase() == "sl") { return <img alt="Korrect"  src={logo_sl} className="width30" /> }
                if (param.IName.toLowerCase() == "sm") { return <img alt="Korrect"  src={logo_sm} className="width30" /> }
                if (param.IName.toLowerCase() == "sn") { return <img alt="Korrect"  src={logo_sn} className="width30" /> }
                if (param.IName.toLowerCase() == "so") { return <img alt="Korrect"  src={logo_so} className="width30" /> }
                if (param.IName.toLowerCase() == "sr") { return <img alt="Korrect"  src={logo_sr} className="width30" /> }
                if (param.IName.toLowerCase() == "ss") { return <img alt="Korrect"  src={logo_ss} className="width30" /> }
                if (param.IName.toLowerCase() == "st") { return <img alt="Korrect"  src={logo_st} className="width30" /> }
                if (param.IName.toLowerCase() == "sv") { return <img alt="Korrect"  src={logo_sv} className="width30" /> }
                if (param.IName.toLowerCase() == "sx") { return <img alt="Korrect"  src={logo_sx} className="width30" /> }
                if (param.IName.toLowerCase() == "sy") { return <img alt="Korrect"  src={logo_sy} className="width30" /> }
                if (param.IName.toLowerCase() == "sz") { return <img alt="Korrect"  src={logo_sz} className="width30" /> }

                if (param.IName.toLowerCase() == "tc") { return <img alt="Korrect"  src={logo_tc} className="width30" /> }
                if (param.IName.toLowerCase() == "td") { return <img alt="Korrect"  src={logo_td} className="width30" /> }
                if (param.IName.toLowerCase() == "tf") { return <img alt="Korrect"  src={logo_tf} className="width30" /> }
                if (param.IName.toLowerCase() == "tg") { return <img alt="Korrect"  src={logo_tg} className="width30" /> }
                if (param.IName.toLowerCase() == "th") { return <img alt="Korrect"  src={logo_th} className="width30" /> }
                //if (param.IName.toLowerCase() == "tj") { return <img alt="Korrect"  src={logo_tj} className="width30" /> }
                if (param.IName.toLowerCase() == "tk") { return <img alt="Korrect"  src={logo_tk} className="width30" /> }
                if (param.IName.toLowerCase() == "tl") { return <img alt="Korrect"  src={logo_tl} className="width30" /> }
                if (param.IName.toLowerCase() == "tm") { return <img alt="Korrect"  src={logo_tm} className="width30" /> }
                if (param.IName.toLowerCase() == "tn") { return <img alt="Korrect"  src={logo_tn} className="width30" /> }
                if (param.IName.toLowerCase() == "to") { return <img alt="Korrect"  src={logo_to} className="width30" /> }
                if (param.IName.toLowerCase() == "tr") { return <img alt="Korrect"  src={logo_tr} className="width30" /> }
                if (param.IName.toLowerCase() == "tt") { return <img alt="Korrect"  src={logo_tt} className="width30" /> }
                if (param.IName.toLowerCase() == "tv") { return <img alt="Korrect"  src={logo_tv} className="width30" /> }
                if (param.IName.toLowerCase() == "tw") { return <img alt="Korrect"  src={logo_tw} className="width30" /> }
                if (param.IName.toLowerCase() == "tz") { return <img alt="Korrect"  src={logo_tz} className="width30" /> }

                if (param.IName.toLowerCase() == "ua") { return <img alt="Korrect"  src={logo_ua} className="width30" /> }
                if (param.IName.toLowerCase() == "ug") { return <img alt="Korrect"  src={logo_ug} className="width30" /> }
                if (param.IName.toLowerCase() == "uk") { return <img alt="Korrect"  src={logo_uk} className="width30" /> }
                if (param.IName.toLowerCase() == "um") { return <img alt="Korrect"  src={logo_um} className="width30" /> }
                if (param.IName.toLowerCase() == "un") { return <img alt="Korrect"  src={logo_un} className="width30" /> }
                if (param.IName.toLowerCase() == "us") { return <img alt="Korrect"  src={logo_us} className="width30" /> }
                if (param.IName.toLowerCase() == "uy") { return <img alt="Korrect"  src={logo_uy} className="width30" /> }
                if (param.IName.toLowerCase() == "uz") { return <img alt="Korrect"  src={logo_uz} className="width30" /> }

                if (param.IName.toLowerCase() == "va") { return <img alt="Korrect"  src={logo_va} className="width30" /> }
                if (param.IName.toLowerCase() == "vc") { return <img alt="Korrect"  src={logo_vc} className="width30" /> }
                if (param.IName.toLowerCase() == "ve") { return <img alt="Korrect"  src={logo_ve} className="width30" /> }
                if (param.IName.toLowerCase() == "vg") { return <img alt="Korrect"  src={logo_vg} className="width30" /> }
                if (param.IName.toLowerCase() == "vi") { return <img alt="Korrect"  src={logo_vi} className="width30" /> }
                if (param.IName.toLowerCase() == "vn") { return <img alt="Korrect"  src={logo_vn} className="width30" /> }
                if (param.IName.toLowerCase() == "vu") { return <img alt="Korrect"  src={logo_vu} className="width30" /> }

                if (param.IName.toLowerCase() == "wf") { return <img alt="Korrect"  src={logo_wf} className="width30" /> }
                if (param.IName.toLowerCase() == "ws") { return <img alt="Korrect"  src={logo_ws} className="width30" /> }

                if (param.IName.toLowerCase() == "ye") { return <img alt="Korrect"  src={logo_ye} className="width30" /> }
                if (param.IName.toLowerCase() == "yt") { return <img alt="Korrect"  src={logo_yt} className="width30" /> }

                if (param.IName.toLowerCase() == "za") { return <img alt="Korrect"  src={logo_za} className="width30" /> }
                if (param.IName.toLowerCase() == "zm") { return <img alt="Korrect"  src={logo_zm} className="width30" /> }
                if (param.IName.toLowerCase() == "zw") { return <img alt="Korrect"  src={logo_zw} className="width30" /> }
                if (param.IName.toLowerCase() == "zz") { return <img alt="Korrect"  src={logo_zz} className="width30" /> }

            })()
        }

    </>)
}